
import axios from "axios";
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
    namespaced: true,
    state: {
        lista: [],
        nome: null,
        id: null,
        perPage: 100,
        registroSelecionadoId: null,
        paginaAtual: 1,
    },
    getters: {
        LISTA: state => {
            return state.lista
        },
        ID: state => {
            return state.id
        },
        NOME: state => {
            return state.nome
        },
        PER_PAGE: state => {
            return state.perPage
        },
        REGISTRO_SELECIONADO_ID: state => {
            return state.registroSelecionadoId
        },
        PAGINA_ATUAL: state => {
            return state.paginaAtual
        }
    },
    mutations: {
        SET_LISTA: (state, payload) => {
            state.lista = payload
        },
        SET_ID: (state, payload) => {
            state.id = payload
        },
        SET_NOME: (state, payload) => {
            state.nome = payload
        },
        SET_PER_PAGE: (state, payload) => {
            state.perPage = payload
        },
        SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
            state.registroSelecionadoId = payload
        },
        SET_PAGINA_ATUAL: (state, payload) => {
            state.paginaAtual = payload
        },
        SET_LIMPAR: (state, payload) => {
            state.lista = []
            state.registroSelecionadoId = null
            state.paginaAtual = 1
        },
    },
    actions: {
        GERAR_LISTA: ({ commit, getters }, { skipConfirmation = false } = {}) => {
            return new Promise((resolve, reject) => {
                let id = (getters.ID !== null ? getters.ID : '')
                let nome = (getters.NOME !== null ? getters.NOME : '')

                if (nome && nome.trim() && /^\d+$/.test(nome.trim())) {
                    id = nome.trim()
                    nome = ''
                }

                let uri = `api/protected/usuario/pesquisar?id=${id}&nome=${nome}`
                axios
                    .post(uri, { nome: nome, id: id }) // The prompt specified POST for search
                    .then(({ data, status }) => {
                        if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
                            resolve({
                                data,
                                status,
                                needsConfirmation: true,
                                count: data.length
                            });
                            return
                        }

                        commit("SET_LISTA", data);
                        if (status === 200 || status === 201) {
                            resolve({ data, status, needsConfirmation: false });
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/usuario-store.js